import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { datadogRum } from '@datadog/browser-rum';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { hmrBootstrap } from './hmr';

if (environment.production) {
  enableProdMode();
}

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule);
if (environment.hmr) {
  if (module['hot']) {
    module['hot'].accept();
    hmrBootstrap(module, bootstrap);
  } else {
    console.error('HMR is not enabled for webpack-dev-server!');
    console.log('Are you using the --hmr flag for ng serve?');
  }
} else {
  bootstrap().catch(err => console.log(err));
}

// skip dataDog SDK initialization on localhost
if (location.hostname !== 'localhost.hansel.io') {
  datadogRum.init({
    applicationId: '3cdd9e28-df7e-44e0-88d7-1a9bbb762aad',
    clientToken: 'pubf601b23d7f2059d3c8e4f8496c852843',
    site: 'datadoghq.com',
    service:'px',
    sampleRate: 100,
    trackInteractions: true
  });
}






